import type { LandingScheduleDay } from '@/types';
import type { LandingVariant, LandingVariantProps } from './landing-variant';
import { ScheduleDays } from './schedule-days';

const STYLES: Record<LandingVariant, { section: string; heading: string }> = {
  ph26: {
    section:
      'theme-ph26-light selection-on-light flex w-full flex-col items-center justify-center bg-background px-6 py-16 text-primary sm:px-10 md:py-24',
    heading:
      'text-center font-title text-5xl leading-tight sm:text-6xl md:text-7xl',
  },
  ar: {
    section:
      'selection-on-light flex w-full flex-col items-center justify-center bg-background px-6 py-16 text-primary sm:px-10 md:py-24',
    heading:
      'text-center font-bold font-title text-5xl leading-tight sm:text-6xl md:text-7xl',
  },
};

// `_components/schedule-slide.tsx`. The grouping the server component did is the
// controller's (LandingEditions.schedule_days_for); an edition with no slots renders
// nothing, the same `return null` as over there.
export function ScheduleSlide({
  dark = false,
  days,
  dateLine,
  timeZone,
  locale,
  variant,
}: {
  dark?: boolean;
  days: LandingScheduleDay[];
  dateLine: string;
  timeZone: string;
  locale: string;
} & LandingVariantProps) {
  const styles = STYLES[variant];

  if (days.length === 0) return null;

  return (
    <section className={dark ? styles.section.replace('theme-ph26-light', 'theme-ph26') : styles.section}>
      <div className="mx-auto w-full max-w-6xl">
        <h2 className={styles.heading}>
          <span className="inline-block bg-primary px-3 py-1 text-background sm:px-4 sm:py-1.5">
            cronograma
          </span>
        </h2>
        <p className="mt-4 text-center font-mono text-primary/70 text-sm md:text-base">
          {dateLine}
        </p>

        <ScheduleDays
          days={days}
          timeZone={timeZone}
          locale={locale}
          variant={variant}
        />
      </div>
    </section>
  );
}
